import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material'
import { boldBlueHeader } from './styles'
import { Bid } from '../../shared/types'
import { formatDateTime, roundToDecimals } from '../../shared/formats.ts'

interface Props {
  bid: Bid
}

export default function ReadOnlyBid({ bid }: Props) {
  const theme = useTheme()

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: theme.palette.grey[200],
        borderRadius: 1,
        px: 2,
        py: 1,
        mt: 0,
        mb: 1,
        boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
        backgroundColor: 'background.paper',
      }}
    >
      <Typography
        variant="h6"
        color={theme.palette.primary.main}
        sx={{ mb: 1 }}
      >
        Bid
      </Typography>
      <Table
        size="small"
        sx={{
          mb: 1,
          border: '1px solid',
          borderColor: theme.palette.grey[200],
        }}
      >
        <TableBody
          sx={{
            '& td, & th': {
              border: '1px solid',
              borderColor: theme.palette.grey[200],
            },
          }}
        >
          <TableRow>
            <TableCell sx={boldBlueHeader}>Rate</TableCell>
            <TableCell>
              {bid.rate != null ? `${roundToDecimals(bid.rate, 3)}%` : '-'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={boldBlueHeader}>Treasury Rate</TableCell>
            <TableCell>
              {bid.treasuryRate != null
                ? `${roundToDecimals(bid.treasuryRate, 3)}%`
                : '-'}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Typography
        variant="subtitle2"
        color={theme.palette.primary.main}
        sx={{ mb: 0.5 }}
      >
        Submitted {formatDateTime(bid.createdAt)}
      </Typography>
      {bid.notes && (
        <>
          <Typography
            variant="subtitle2"
            color={theme.palette.primary.main}
            sx={{ mb: 0.5 }}
          >
            Additional Notes
          </Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            {bid.notes}
          </Typography>
        </>
      )}
    </Box>
  )
}
